<template>
  <div class="bottom-safe">
    <div class="block">
      <van-search
        :readonly="true"
        placeholder="搜搜感兴趣的私房课"
        @click="clickSearch"
      ></van-search>
    </div>
    <div class="block">
      <top-swipe />
    </div>
    <div class="block">
      <block-notice />
    </div>
    <div class="block">
      <block-today-recommends />
    </div>
    <div class="block">
      <block-latest-episodes />
    </div>
    <div class="block">
      <block-topic />
    </div>
    <div class="block">
      <block-top-episodes />
    </div>
  </div>
</template>

<script>
  import TopSwipe from '../blocks/top-swipe/index'
  import BlockNotice from '../blocks/notice/index'
  import BlockTopic from '../blocks/topic/index'
  import BlockLatestEpisodes from '../blocks/latest-episodes/index'
  import BlockTodayRecommends from '../blocks/today-recommends/index'
  import BlockTopEpisodes from '../blocks/top-episodes/index'

  export default {
    // inject: ['reload'],
    name: "Discovery",
    components: {
      TopSwipe,
      BlockNotice,
      BlockTopic,
      BlockLatestEpisodes,
      BlockTodayRecommends,
      BlockTopEpisodes,
    },
    data () {
      return {
      }
    },
    methods: {
      clickSearch () {
        this.$router.replace({
          name: 'SearchPage',
          params: {}
        })
      }
    },
    mounted () {
    }
  }
</script>

<style lang="css" scoped>
  .block {
    /* padding: 0 3vw; */
    margin-bottom: 10px;
  }
</style>
